import { useRef, useEffect, useState } from 'react';
import camImg from "../assets/images/camera.png";
import homestyles from "../assets/styles/home.module.css"
import styles from '../assets/styles/scanner.module.css'
import jsQR from 'jsqr';
import Toast from '../lib/toast';
import { useDeviceInfo } from '../lib/mobile';

function QRScanner({setScanResult}){
    const videoRef = useRef(null);
    const frameRef = useRef(null);
    const scanningRef = useRef(false);
    const {device} = useDeviceInfo();
    const canvasRef = useRef(null);
    const [cameraOn, setCameraOn] = useState(false)
    const [loading, setLoading] = useState(false);

    /**
     * Turns the camera on for scanning
     * @returns 
     */
    async function startCamera(){
        if (scanningRef.current) return;
        setCameraOn(true);
        setLoading(true);
        scanningRef.current = true;
        
        const currentSession = {}; // unique object to track this session
        scanningRef.current = currentSession;

        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: 'environment',
                    width: { max: 1920 },
                    height: { max: 1080 }
                }
            });
            stream.getVideoTracks()[0].onended = () => {
                console.warn("Camera stream stopped by browser or OS");
            };
            if (scanningRef.current !== currentSession) {
                stream.getTracks().forEach(track => track.stop());
                return;
            }
            if (!videoRef.current) return;
            
            videoRef.current.srcObject = stream;


            const handleVideoStart = () => {
                setLoading(false);
                videoRef.current.removeEventListener("playing", handleVideoStart);
                videoRef.current.removeEventListener("loadeddata", handleVideoStart);
            };

            // Make sure we stop loading when either event fires
            videoRef.current.addEventListener("playing", handleVideoStart);
            videoRef.current.addEventListener("loadeddata", handleVideoStart);

            await videoRef.current.play();
            scanQRCode();
        } catch (err) {
                Toast.error("Error accessing camera")
                console.error("Error accessing camera:", err);
            
            setCameraOn(false)
            scanningRef.current = false;
        }
    }

    /**
     * Turns off the camera
     */
    function stopCamera() {
        setLoading(false);
        setCameraOn(false);
        scanningRef.current = false;
        if (videoRef.current && videoRef.current.srcObject) {
            videoRef.current.srcObject.getTracks().forEach(track => track.stop());
        }
    }

    /**
     * Camera starts to check for QR codes
     */
    async function scanQRCode() {
        const video = videoRef.current;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d', { willReadFrequently: true });

        const useNative = 'BarcodeDetector' in window;
        const detector = useNative ? new window.BarcodeDetector({ formats: ['qr_code'] }) : null;

        const tick = async () => {
            if (!scanningRef.current) return;

            if (video.readyState === video.HAVE_ENOUGH_DATA && frameRef.current) {
                const vw = video.videoWidth;
                const vh = video.videoHeight;
                canvas.width = vw;
                canvas.height = vh;
                ctx.drawImage(video, 0, 0, vw, vh);

                // Get overlay frame position relative to video element
                // const videoRect = video.getBoundingClientRect();
                // const frameRect = frameRef.current.getBoundingClientRect();

                // const xRatio = vw / videoRect.width;
                // const yRatio = vh / videoRect.height;

                // const boxX = (frameRect.left - videoRect.left) * xRatio;
                // const boxY = (frameRect.top - videoRect.top) * yRatio;
                // const boxSize = frameRect.width * xRatio;

                // const imageData = ctx.getImageData(boxX, boxY, boxSize, boxSize);

                const imageData = ctx.getImageData(0, 0, vw, vh);

                let result = null;

                if (useNative) {
                    try {
                        const barcodes = await detector.detect(video);
                    if (barcodes.length > 0) result = barcodes[0].rawValue;
                    } catch (err) {
                        console.warn("BarcodeDetector failed:", err);
                    }
                }

                if (!result) {
                    const code = jsQR(imageData.data, imageData.width, imageData.height, {
                    inversionAttempts: "attemptBoth",
                    });
                    if (code) result = code.data;
                }

                if (result) {
                    setScanResult(result);
                    Toast.success("QR Detected!");
                    stopCamera();
                    return;
                }
            }

            requestAnimationFrame(tick);
        };

        requestAnimationFrame(tick);
    }

    useEffect(() => {
        // Cleanup on unmount
        return () => { stopCamera()};
    }, []); // Rerun effect if scanResult changes to stop scanning

    const handleFile = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        const img = new Image();
        img.crossOrigin = "anonymous";

        reader.onload = () => {
            img.onload = () => {
            const canvas = canvasRef.current;
            const ctx = canvas.getContext("2d", { willReadFrequently: true });

            // Draw image at natural resolution
            const w = img.naturalWidth || img.width;
            const h = img.naturalHeight || img.height;
            canvas.width = w;
            canvas.height = h;
            const scale = 2;
                canvas.width = w * scale;
                canvas.height = h * scale;
                ctx.imageSmoothingEnabled = false;
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, w, h);

            // Extract image data for QR decoding
            const imageData = ctx.getImageData(0, 0, w, h);
            const code = jsQR(imageData.data, w, h, {
                inversionAttempts: "attemptBoth",
            });

            if (code) {
                setScanResult(code.data);
                Toast.success("QR code detected!");
            } else {
                Toast.error("No QR code found in this image.");
            }
            };

            img.src = reader.result;
        };

        reader.readAsDataURL(file);
    };
    if(device === "desktop"){
        return (
            <div className='invisible'>
                why hello there
            </div>
        )
    }
    else if((device === "mobile" || device === "tablet")){
        return (
            <div className={styles.qrscannerContainer}>
            {cameraOn === false ? (
                <img alt="camera" className={homestyles.imgBtn} src={camImg} onClick={() => startCamera()}/>
            ) : (
                <>
                    <span className='tint'></span>
                    <div className={styles.videoContainer}>
                        <div className={styles.header}>
                            <span className={styles.scanningText}>
                                <div className={loading ? "invisible" : '' }>
                                    {"Scanning for"}
                                </div>
                                <div>
                                    {loading ? "Starting Camera" : 'QR Code'}
                                    <span className={styles.dot}></span>
                                    <span className={styles.dot}></span>
                                    <span className={styles.dot}></span>
                                </div>
                                
                                
                            </span>
                        </div>
                        <button className={styles.exitButton} onClick={() => stopCamera()}>✕</button>
                        <div className={loading ? styles.videoRef : 'invisible'}>
                            <div className='spinner'></div>
                        </div>
                        <div ref={frameRef} className={styles.scanOverlay}>
                            <div className={styles.scanFrame}>
                                <div className={`${styles.corner} ${styles.tl}`}></div>
                                <div className={`${styles.corner} ${styles.tr}`}></div>
                                <div className={`${styles.corner} ${styles.bl}`}></div>
                                <div className={`${styles.corner} ${styles.br}`}></div>
                            </div>
                        </div>
                        <video
                            ref={videoRef}
                            className={`${styles.videoRef} ${loading ? styles.videoLoading : styles.videoReady}`}
                            playsInline
                            muted
                        />                    
                        <canvas ref={canvasRef} style={{ opacity: '0' }} /> {/* Hidden canvas for processing */}
                        
                    </div>
                
                </>
            )}
            </div>
            // <div className={styles.qrscannerContainer}>
            //     <label className={homestyles.imgBtn}>
            //         <img alt="camera" src={camImg} />
            //         <input
            //         type="file"
            //         accept="image/*"
            //         capture="environment"
            //         onChange={handleFile}
            //         style={{ display: "none" }}
            //         />
            //     </label>
            //     <canvas ref={canvasRef} style={{ display: "none" }} />
            // </div>
        );
    }
    else{
        return (
        <div className={styles.qrscannerContainer}>
                 <label className={homestyles.imgBtn}>
                    <img alt="camera" src={camImg} />
                    <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    onChange={handleFile}
                    style={{ display: "none" }}
                    />
                </label>
                <canvas ref={canvasRef} style={{ display: "none" }} />
            </div>
        )
    }
};

export default QRScanner;